import { createRouter, createWebHistory } from 'vue-router';

//import {
//    Layout,
//    Login,
//    Logout,
//    Register,
//    NotAuthorized
//} from './index';

const Layout = () => import('./_shared/layout.vue')
const Login = () => import('./views/login.vue')
const Logout = () => import('./views/logout.vue')
const Register = () => import('./views/register.vue')
const NotAuthorized = () => import('./views/not-authorized.vue')

const baseUrl = '/accounts';// import.meta.env.BASE_URL;

const localRoutes = {
    path: '/',
    component: Layout,
    props: false,
    meta: {
        //requiresAuth: true,
        //roles: ['Member']
    },
    children: [
        { path: '', component: Login },
        { path: 'login', component: Login },
        { path: 'logout', component: Logout },
        { path: 'register', component: Register },
        { path: 'not-authorized', component: NotAuthorized },
    ]
};

export const router = createRouter({
    history: createWebHistory(baseUrl),
    linkActiveClass: 'active',
    routes: [
        { ...localRoutes },
        // catch all redirect to home page
        { path: '/:pathMatch(.*)*', redirect: '/' }
    ]
});

//router.beforeEach(async (to) => {
//    debugger;

//    return;
//    eventBus.$emit('chat:close');

//    // clear alert on route change
//    const alertStore = useAlertStore();
//    alertStore.clear();

//    var meta = to.meta;
//    // redirect to login page if not logged in and trying to access a restricted page 
//    const publicPages = ['/', '/account/login', '/account/logout', '/account/register'];
//    const authRequired = meta.requiresAuth && !publicPages.includes(to.path);
//    const authStore = useAuthStore();
//    const user = authStore.user;

//    //debugger
//    if (authRequired && !user) {
//        authStore.returnUrl = to.fullPath;
//        return {
//            path: '/account/login/',
//            query: { returnUrl: encodeURIComponent(to.fullPath) }
//        };
//    }

//    var roles = to.meta.roles;

//    if (roles && !authStore.user.roles.some(e => roles.includes(e))) {
//        //debugger
//        //toasts.error('Page Error', `Not authorized to access this view/page.`)
//        alert('You are not authorized to acccess this page.')
//        //return false;
//        return {
//            path: '/account/login/',
//            query: { returnUrl: encodeURIComponent(to.fullPath) }
//        };
//    }
//});